import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';
import queryString from 'qs';
import Form from '../../components/Form';

import { login, isAuthenticated, forgotPassword } from '../../auth'
import { isClient } from '../../utils'
import { updateSettings, getSettings } from '../../settings'
import { media } from '../../styles/utils';
import { hoverState, padding } from '../../styles/global';
import { cream, cream2 } from '../../styles/colors';

class ForgotPassword extends Component {

    state = {
        validationError: null,
        success: null,
    }

    submitLostPassword = (formData) => {
        const { updateSettings } = this.props;

        let self = this;

        forgotPassword(formData)
            .then(response => {   
                self.setState({
                    validationError: null,
                    success: 'Reset password link had been sent to your email'
                })
            })
            .catch(error =>  {
                self.setState({
                    validationError: 'User not found',
                    success: null
                })
            })   
    }
    
    render() {       
        const { validationError, success } = this.state; 

        const fields = [
            {
                type: 'email',
                name: 'user_login',
                placeholder: 'Email Address'
            },
        ]
        
        return (
            <Container>

                <Form
                    heading={'Forgot Password'}
                    callback={(formData) => this.submitLostPassword(formData)}
                    fields={fields}
                    submitLabel={'Submit'}
                />

                {validationError && (
                    <ValidationError>
                        {validationError}
                    </ValidationError>
                )}

                {success && (
                    <Success>
                        {success}
                    </Success>
                )}
            </Container>
        )        
    }
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 65px); 
    padding: ${padding};
`

const ValidationError = styled.div`
    color: red;
    position: absolute;
    bottom: 24px;
`

const Success = styled.div`
    color: green;
    position: absolute;
    bottom: 24px;
`

const mapDispatchToProps = dispatch => ({
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: getSettings(state)
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword));



// WEBPACK FOOTER //
// ./client/modules/ForgotPassword/ForgotPassword.js